import { useState } from 'react';

import { useLogService } from '../../hooks/useLogService';
import { useMarket } from '../../providers/MarketProvider';
import type { FormFields, SubscriptionLocation } from './Newsletter.types';
import { performSubscribeNewster } from './Newsletter.utils';

export const useNewsletterSubscription = (location: SubscriptionLocation) => {
  const market = useMarket();
  const { logError, logEvent } = useLogService();

  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const onSubmit = async (data: FormFields) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const response = await performSubscribeNewster(data);
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }

      logEvent('newsletter_subscription_success', undefined, {
        location,
      });

      setIsSuccess(true);
    } catch (e) {
      setIsError(true);
      logError(e, {
        extra: {
          market,
          location,
          username: data.email,
        },
      });
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    isSuccess,
    onSubmit,
  };
};
